import React from "react";

const TelMob = props => {
    return (<a href={props.num ?? "tel:+381615796175"} className={props.color ?? ''} rel="noreferrer" target="_blank" > {props.children}</a>)
}

export default TelMob;